import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetPriceGraphic(club, date, salesChannel) {

  var url = "/reservation/one_day_reservation_price_calendar/" + club + "/" + date + "/" + salesChannel; 

  return FetchGetDataWithAuthNEW(url);
}

